@if (!loading) {
<div class="box">
  <button mat-button class="back-btn" (click)="back()">
    <mat-icon>arrow_back</mat-icon> Back
  </button>

  <div class="page-header">
    <div>
      <p class="page-title">Admins</p>
      <p class="page-desc">Admins have elevated access to manage <strong>{{ applicationName }}</strong>. Add trusted team members who need to configure this application.</p>
    </div>
    <button mat-flat-button class="add-btn" (click)="openModal(admin, 'New', applicationName, false)">
      <mat-icon>add</mat-icon>
      Add Admin
    </button>
  </div>

  <div class="stats-row">
    <div class="stat-card">
      <div class="stat-icon stat-icon--total">
        <mat-icon>admin_panel_settings</mat-icon>
      </div>
      <div class="stat-info">
        <span class="stat-value">{{ adminCount }}</span>
        <span class="stat-label">Admins</span>
      </div>
    </div>
  </div>

  <div class="table-toolbar">
    <mat-form-field class="search-field">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput (keyup)="applyFilter($event)" placeholder="Search admins…" />
    </mat-form-field>
  </div>

  <div class="table-container">
    <table mat-table [dataSource]="dataSource" matSort>

      <ng-container matColumnDef="icon">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <div class="row-icon"><mat-icon>manage_accounts</mat-icon></div>
        </td>
      </ng-container>

      <ng-container matColumnDef="application">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>App Name</th>
        <td mat-cell *matCellDef="let element">{{ element.application }}</td>
      </ng-container>

      <ng-container matColumnDef="admin_email">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Email</th>
        <td mat-cell *matCellDef="let element">{{ element.admin_email }}</td>
      </ng-container>

      <ng-container matColumnDef="Description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
        <td mat-cell *matCellDef="let element">{{ element.Description }}</td>
      </ng-container>

      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button class="action-btn" title="Edit"
                  (click)="openModal(element, 'Edit', applicationName, true); $event.stopPropagation()">
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <tr *matNoDataRow>
        <td colspan="5">
          <div class="empty-state">
            <mat-icon>person_off</mat-icon>
            <p>No admins found</p>
          </div>
        </td>
      </tr>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"
          class="table-row" (click)="openModal(row, 'Edit', applicationName, true)"></tr>
    </table>
  </div>

  <mat-paginator [pageSizeOptions]="[5, 10, 25]" showFirstLastButtons aria-label="Select page">
  </mat-paginator>
</div>
}
@if (loading) {
  <app-loading-spinner></app-loading-spinner>
}
